import * as BoxC from "./_ccbBoxC";
import * as SrlC from "./_ccbSrlC";
import * as GridC from "./_cccGridC";
import { a } from "./_cmABT";
import * as _cr from "./_cr";
import * as _ls from "./_csLcl";
import * as _ht from "./_ht";

export const N = (pz: {
  sPz: _ht.dz,
/*
  dsnz?: {
    pageBtnH?: _ht.n,
    pageHdrH?: _ht.n,
    pageW?: _ht.n,
  },
*/
  hdrClds: _ht.ls,
  schStlz?: _ht.dz,
  schClds: _ht.ls,
  btnStlz?: _ht.ls,
  btnClds: _ht.ls,
  topStlz?: _ht.dz,
  topClds: _ht.ls,
  cttStlz?: _ht.dz,
  cttClds: _ht.ls,
}) => {

//  const _pageW = pz.dsnz?.pageW ?? 128;

  return (

    _cr.c(GridC.N, {
      boxStlz: a(`dh/main dw/main fd/csc sc/lt1`),
      lineCs: [

        pz.hdrClds ?
        {
          boxStlz: a(`dw/f`),
          cellCs: [
            {
              boxStlz: a(`dw/f`),
              boxClds: 
                pz.hdrClds,
            }
          ]
        }
        : undefined,

        pz.sPz.crt.steps[0] == 0 && pz.btnClds ?
        {
          boxStlz: a(`dh/mainFtn dw/f fd/rac`),
          cellCs: [
            {
              boxStlz: {
                ... a(`dw/f dwx/w6`),
                ... pz.btnStlz
              },
              boxClds: 
                pz.btnClds,
            }
          ]
        }
        :undefined,

        pz.sPz.crt.steps[0] == 0 && pz.schClds ?
        {
          boxStlz: a(`dw/f fd/ccc mb/2`),
          cellCs: [
            {
              boxStlz: {
//                ... a(`br/1 dw/f dwx/w6 p/1 sc/lt3`),
                ... a(`dw/f dwx/w6`),
                ... pz.schStlz
              },
              boxClds: pz.schClds,
            }
          ]
        }
        :undefined,

        pz.sPz.crt.steps[0] == 0 && pz.topClds ?
        {
          boxStlz: a(`dw/f f/1`),
          cellCs: [
            {
              boxStlz: a(`dw/f dh/f`),
              boxClds: [

                _cr.c(SrlC.N, {
                  srlClds: [
                    _cr.c(BoxC.N, {
                      boxStlz: {
                        ... a(`dw/f dwx/w6`),
                        ... pz.topStlz
                      },
                      boxClds: pz.topClds,
                    })
                  ]
                }),

              ]
            }
          ]
        }
        :undefined,

        pz.sPz.crt.steps[0] == 1 && pz.cttClds ?
        {
          boxStlz: a(`dw/f f/1`),
          cellCs: [
            {
              boxStlz: a(`dw/f dh/f`),
              boxClds: [

                _cr.c(SrlC.N, {

                  srlClds: [

                    _cr.c(BoxC.N, {
                      boxStlz: {
                        ... a(`dw/f dwx/w3`),
                        ... pz.cttStlz
                      },
                      boxClds: pz.cttClds,
                    })

                  ]
                }),

              ]
            }
          ]
        }
        :undefined,

        pz.sPz.crt.steps[0] == 1 && pz.btnClds ?
        {
          boxStlz: a(`dh/mainFtn dw/f mb/1 fd/rac`),
          cellCs: [
            {
              boxStlz: {
                ... a(`dw/f dwx/w6`),
                ... pz.btnStlz
              },
              boxClds: 
                pz.btnClds,
            }
          ]
        }
        :undefined,

      ]
    })
  );

};
